import React from 'react'

const SideProfileIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0003 8.33335C11.8413 8.33335 13.3337 6.84097 13.3337 5.00002C13.3337 3.15907 11.8413 1.66669 10.0003 1.66669C8.15938 1.66669 6.66699 3.15907 6.66699 5.00002C6.66699 6.84097 8.15938 8.33335 10.0003 8.33335Z" fill="#29292B" />
            <path opacity="0.5" d="M16.6663 14.5833C16.6663 16.6541 16.6663 18.3333 9.99967 18.3333C3.33301 18.3333 3.33301 16.6541 3.33301 14.5833C3.33301 12.5125 6.31801 10.8333 9.99967 10.8333C13.6813 10.8333 16.6663 12.5125 16.6663 14.5833Z" fill="#29292B" />
        </svg>

    )
}

export default SideProfileIcon
